import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {

  private apiKey = 'sk_ff4334a76415e979f346621c38d91f6cd4297584e042af16'; // ElevenLabs API anahtarınızı buraya koyun
  private apiUrl = 'https://api.elevenlabs.io/v1/text-to-speech/'; // API temel URL'i

  constructor(private http: HttpClient) {}

  textToSpeech(text: string, voiceId: string = 'HllA1j2zLOqUQ4kLjMmK'): any {
    const headers = new HttpHeaders()
      .set('xi-api-key', this.apiKey)
      .set('Content-Type', 'application/json');

    const body = {
      text,
      model_id: 'eleven_multilingual_v2',
    };

    return this.http.post(`${this.apiUrl}${voiceId}`, body, {
      headers,
      responseType: 'blob', // Yanıtı bir Blob olarak al
    });
  }

  isSpeechSynthesisSupported(): boolean {
    return 'speechSynthesis' in window;
  }

  readText(text: string): void {
    if (!this.isSpeechSynthesisSupported()) {
      alert('Tarayıcınız metin okuma desteği sağlamıyor.');
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'tr-TR';
    utterance.pitch = 0.5;
    utterance.rate = 1;
    utterance.volume = 2;
    window.speechSynthesis.speak(utterance);
  }

  stopReading(): void {
    if (this.isSpeechSynthesisSupported()) {
      window.speechSynthesis.cancel();
    }
  }
}
